export const useDefaultData = ({ Helpers }) => {

    const { getCurrentDate } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idmanagement: '',
        idmanagementtypes: '',
        idreception: '',
        recepcion_codigo: '',
        gestion_fecha: getCurrentDate(),
        gestion_usuario: '',
        gestion_descripcion: '',
        info_descuento: '',
        info_descuento_aprobado: '',
        aprobacion_check: '',
        aprobacion_usuario: '',
        aprobacion_fecha: getCurrentDate(),
        aprobacion_observaciones: '',
        infoReception: []
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}